import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import AlgoliaFactory from '@/model/algolia';
import { getLocale } from '@/utils';

export const fetchSearchGames = async (context: LogicContext) => {
  const Algolia = AlgoliaFactory({
    ...config.algolia.config,
  });
  const phrase = context.search.searchPhrase;

  if (!phrase || phrase.length < 3) {
    return {
      search: {
        ...context.search,
        searchItems: [],
      },
    };
  }

  const filters = [
    `${config.viewer_country}-${config.viewer_region}`,
    `${config.viewer_country}-EMPTY`,
    'EMPTY',
  ];

  const { items: searchItems, queryID, userToken } = await Algolia.searchItems(
    phrase,
    filters,
    getLocale(config),
    config.base_path
  );

  return {
    search: {
      ...context.search,
      searchItems,
      currentType: 'All',
      queryID,
      userToken,
    },
  };
};
